"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryHeaderSwitch = void 0;
const tslib_1 = require("tslib");
const css_1 = require("@emotion/css");
const lodash_1 = require("lodash");
const react_1 = tslib_1.__importStar(require("react"));
const ui_1 = require("@grafana/ui");
const QueryEditor_1 = require("../../QueryEditor");
function QueryHeaderSwitch(_a) {
    var { label } = _a, inputProps = tslib_1.__rest(_a, ["label"]);
    const dashedLabel = label.replace(' ', '-');
    const switchIdRef = (0, react_1.useRef)((0, lodash_1.uniqueId)(`switch-${dashedLabel}`));
    const styles = (0, ui_1.useStyles2)(getStyles);
    return (react_1.default.createElement(QueryEditor_1.EditorStack, { gap: 1 },
        react_1.default.createElement("label", { htmlFor: switchIdRef.current, className: styles.switchLabel }, label),
        react_1.default.createElement(ui_1.Switch, Object.assign({}, inputProps, { id: switchIdRef.current }))));
}
exports.QueryHeaderSwitch = QueryHeaderSwitch;
const getStyles = (theme) => {
    return {
        switchLabel: (0, css_1.css)({
            color: theme.colors.text.secondary,
            cursor: 'pointer',
            fontSize: theme.typography.bodySmall.fontSize,
            '&:hover': {
                color: theme.colors.text.primary,
            },
        }),
    };
};
//# sourceMappingURL=QueryHeaderSwitch.js.map